import { Response } from '@angular/http';
import { Injectable } from '@angular/core';

// Rxjs
import { _throw } from 'rxjs/observable/throw';
import { Observable } from 'rxjs/Observable';

// Services
import { HttpService } from './http.service';

// Base URL
import { BASE_URL } from './api';

@Injectable()
export class ParticipantStatementSearch {

  // Base URL
  private PATH: string = BASE_URL + 'search/';

  // Constructor
  constructor(private http: HttpService) { }

  // Search for a participant or statement
  public searchForParticipantStatement(data: { search_word: string, project_id?: number }): Observable<Response> {
    return this.http.post(this.PATH + 'search/participants-and-statements', data);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/participant-statement-search.service.ts